import { IconButton, Stack } from "@mui/material";
import { CleaningRobotItem } from "types/response/robot";
import { SettingRobotDialog } from "../Setting/SettingRobot/SettingRobotDialog";
import { useModal } from "hooks/useModal";
import { notify } from "lib/notify";
import EditIcon from "@mui/icons-material/Edit";

type RobotDetailHeaderMenuProps = { robot: CleaningRobotItem };

const RobotDetailHeaderMenu = ({ robot }: RobotDetailHeaderMenuProps) => {
  const settingModal = useModal();

  const onClickSaveInfo = async () => {
    notify("保存しました。");
    settingModal.onClose();
  };

  return (
    <>
      <Stack
        direction={"row"}
        spacing={1}
        sx={{
          mt: 1,
          mr: { xs: 0, md: 2 },
          alignItems: "flex-start",
          justifyContent: "flex-start",
        }}
      >
        <IconButton onClick={settingModal.onOpen}>
          <EditIcon color="primary" />
        </IconButton>
      </Stack>
      <SettingRobotDialog
        open={settingModal.open}
        robot={robot}
        onClickSave={onClickSaveInfo}
        onClickCancel={() => settingModal.onClose()}
        hideEnabledSetting
      />
    </>
  );
};

export default RobotDetailHeaderMenu;
